/**
 * <ExportDropdown> — the trigger button + menu items. Pure view.
 */
import React from 'react';
import { Printer, Download, FileSpreadsheet, FileText, Sheet, FileType, Mail } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from '../ui/dropdown-menu';
import { STEEL_PILL_GRADIENT } from './constants';

const ExportDropdown = ({
  label,
  testIdPrefix,
  isPro,
  pdfBusy,
  onPrint,
  onCSV,
  onXLSX,
  onPDF,
  onGoogleSheets,
  onEmail,
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        variant="outline"
        className="bg-white border border-[#E2E8F0] text-[#020617] hover:bg-[#F8FAFC] print-hide"
        data-testid={`${testIdPrefix}-trigger`}
      >
        <Download className="w-4 h-4 mr-2" />
        {label}
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-60 bg-white print-hide">
      <DropdownMenuLabel className="text-xs uppercase tracking-[0.2em] text-[#64748B]">This page</DropdownMenuLabel>
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={onPrint} data-testid={`${testIdPrefix}-print`} className="cursor-pointer">
        <Printer className="w-4 h-4 mr-2 text-[#475569]" />
        Print
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onCSV} data-testid={`${testIdPrefix}-csv`} className="cursor-pointer">
        <FileText className="w-4 h-4 mr-2 text-[#475569]" />
        Export CSV
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onXLSX} data-testid={`${testIdPrefix}-xlsx`} className="cursor-pointer">
        <FileSpreadsheet className="w-4 h-4 mr-2 text-[#475569]" />
        Export Excel (.xlsx)
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onPDF} disabled={pdfBusy} data-testid={`${testIdPrefix}-pdf`} className="cursor-pointer">
        <FileType className="w-4 h-4 mr-2 text-[#475569]" />
        {pdfBusy ? 'Building PDF…' : 'Export PDF'}
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onGoogleSheets} data-testid={`${testIdPrefix}-gsheets`} className="cursor-pointer">
        <Sheet className="w-4 h-4 mr-2 text-[#475569]" />
        Export to Google Sheets
      </DropdownMenuItem>
      <DropdownMenuSeparator />
      <DropdownMenuItem onClick={onEmail} data-testid={`${testIdPrefix}-email`} className="cursor-pointer">
        <Mail className="w-4 h-4 mr-2 text-[#475569]" />
        <span className="flex-1">Email…</span>
        {!isPro && (
          <span
            className="ml-2 inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider text-white leading-none"
            style={{ backgroundImage: STEEL_PILL_GRADIENT }}
          >
            Steel
          </span>
        )}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
);

export default ExportDropdown;
